function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'taupe': 'rgb(172, 160, 156)','magenta': 'rgb(127, 35, 103)','lila': 'rgb(127, 35, 103)','grau-meliert': 'rgb(172, 172, 172)','hellgrau': 'rgb(181, 182, 181)','silber': 'rgb(181, 182, 181)','navy': 'rgb(43, 68, 83)','nachtblau': 'rgb(43, 68, 83)','altrosa': 'rgb(203, 165, 179)','tannengrun': 'rgb(45, 87, 62)','flaschengrun': 'rgb(45, 87, 62)','jeansblau': 'rgb(101, 144, 188)','burgund': 'rgb(118, 51, 73)','khaki': 'rgb(91, 92, 83)','grau': 'rgb(128, 128, 128)','mintgrun': 'rgb(182, 228, 208)','milk': 'rgb(246, 242, 232)','sand': 'rgb(194, 179, 161)','natur': 'rgb(204, 191, 174)','lavendel': 'rgb(168, 167, 188)','pink': 'rgb(217, 71, 126)','rostrot': 'rgb(160, 90, 63)','schwarz': 'rgb(0, 0, 0)','schwarz-meliert': 'rgb(85, 85, 85)','braun': 'rgb(128, 64, 32)','oliv': 'rgb(104, 121, 84)','weiss': 'rgb(247, 247, 247)','orange': 'rgb(255, 165, 0)','weizenstroh': 'rgb(183, 172, 154)','dunkelgrau': 'rgb(84, 84, 84)','dunkelgrau-meliert': 'rgb(84, 84, 84)','petrol': 'rgb(33, 131, 131)','dunkelgrun': 'rgb(0, 100, 0)','rosa': 'rgb(255, 182, 193)','hellgrun': 'rgb(50, 205, 50)','mint': 'rgb(204, 255, 229)','blau': 'rgb(65, 105, 225)','aquamarin': 'rgb(152, 220, 165)','butter': 'rgb(248, 241, 200)','grun': 'rgb(41, 182, 38)','pflaume': 'rgb(111, 58, 128)','rot': 'rgb(191, 59, 59)','lime': 'rgb(110, 179, 56)','honig': 'rgb(236, 200, 137)','kastanie': 'rgb(72, 53, 59)','baggersee': 'rgb(108, 128, 121)','feldgrun': 'rgb(129, 147, 111)','senf': 'rgb(216, 161, 0)','gelb': 'rgb(216, 161, 0)','himmelblau': 'rgb(186, 207, 234)','pfirsich': 'rgb(230, 188, 163)','weizenstroh': 'rgb(234, 211, 161)','sunrise': 'rgb(225, 111, 88)',};

    this.images = {};

    this.triggers = ['farbe',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
